import { httpConfig } from "../../../config/http-config";

export interface GenericFormUrlArgs {
  type: "catalogs";
  catalogId: string;
}
export interface SupplierFormUrlArgs {
  type: "suppliers" | "support" | "leads";
}

type FormUrlArgs = GenericFormUrlArgs | SupplierFormUrlArgs;

export function getFormUrl(args: FormUrlArgs = { type: "leads" }) {
  let apiSuffix = httpConfig.apiSuffix.leads;

  switch (args.type) {
    case "catalogs":
      apiSuffix = getCatalogApiSuffix(args.catalogId);
      break;
    case "suppliers":
      apiSuffix = httpConfig.apiSuffix.suppliers;
      break;
    case "support":
      apiSuffix = httpConfig.apiSuffix.support;
      break;
  }

  if (process.env.NODE_ENV === "development") {
    return `${httpConfig.postApi}${apiSuffix}`;
  }

  return httpConfig.url + httpConfig.postApi + apiSuffix;
}

const getCatalogApiSuffix = (catalogId: string) =>
  `${httpConfig.apiSuffix.catalogs[0]}${catalogId}${httpConfig.apiSuffix.catalogs[1]}`;
